import { Outlet } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import { AppProvider } from './providers/AppProvider';
import { FeatureFlagProvider } from './providers/FeatureFlagProvider';
import { ColorSwitch } from './components/layout/ColorSwitch';
import { LanguageSelector } from './components/LanguageSelector';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});

export function PublicLayout() {
  return (
    <AppProvider>
      <QueryClientProvider client={queryClient}>
        <FeatureFlagProvider>
          <div className="flex flex-col">
            <header className="absolute top-0 z-10 flex items-center justify-end w-full bg-background">
              <div className="flex items-center gap-2">
                <LanguageSelector />
                <ColorSwitch />
              </div>
              
            </header>
            <main className="flex-1 overflow-hidden">
              <Outlet />
            </main>
          </div>
        </FeatureFlagProvider>
      </QueryClientProvider>
    </AppProvider>
  );
}
